const prefix = 'hc-emphasized-text';

export const EmphasizedTextClassNames = {
  Root: `${prefix}-root`,
  Match: `${prefix}-match`,
};
